import { ReactNode, useEffect } from 'react';
import { X } from 'lucide-react';

interface SidePanelProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}

export function SidePanel({ open, onClose, title, children }: SidePanelProps) {
  useEffect(() => {
    if (!open) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [open, onClose]);

  return (
    <div className={`panel-overlay ${open ? 'open' : ''}`}>
      <div className="panel-overlay-bg" onClick={onClose} />
      <div className="panel-slide">
        <div className="panel-slide-head">
          <h3 className="panel-slide-title">{title}</h3>
          <button className="panel-slide-close" onClick={onClose}><X className="icon-sm" /></button>
        </div>
        <div className="panel-slide-body">
          {children}
        </div>
      </div>
    </div>
  );
}
